
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M12.6431 16.3572L9.10742 19.8929C7.86478 21.1355 5.85006 21.1355 4.60742 19.8929V19.8929C3.36478 18.6502 3.36478 16.6355 4.60742 15.3929L8.14314 11.8572"></path><path d="M15.8572 13.1428L19.3929 9.60712C20.6355 8.36447 20.6355 6.34977 19.3928 5.10713V5.10713C18.1502 3.86448 16.1355 3.86449 14.8928 5.10715L11.3572 8.6428"></path><path opacity="0.9" d="M17.1428 15.7143L21 15.7143"></path><path opacity="0.9" d="M15.2151 17.6428L15.2151 21.5"></path><path opacity="0.9" d="M8.78639 7.35716V3.50002"></path><path opacity="0.9" d="M6.85714 9.28571H3"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiUnlink",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
